// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__c92DJ","content":"styles_content__sjP_t","paragraph":"styles_paragraph__UNiCK","methods":"styles_methods__VcuoG"};